import { get } from 'lodash/object'
import Shortcode from '~/modules/shortcodes/models/Shortcode'

export default async function ({ route, $config }) {
  const { token, documentId } = get(
    await Shortcode.api().filter({ save: true }).read(route.params.id),
    'response.data'
  )
  window.location.href = `${$config.webURL}/documents/${documentId}?token=${token}`
}
